import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { aggregationService } from '@/api/services/aggregation';
import { iamService } from '@/api/services/iam';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/cloud-access/roles')({
  beforeLoad: ({ params, matches }) => {
    // The bare URL goes back up to the subtree entrypoint rather than straight to `all-users`: whoever
    // cannot read users gets re-routed to a tab they can read, instead of landing on an Access Denied.
    if (matches.at(-1)?.routeId === Route.id) {
      throw redirect({
        to: '/accounts/$accountId/cloud-access',
        params,
        replace: true,
      });
    }

    const listPermissionsQuery = iamService.listPermissionsQuery({ accountId: params.accountId });
    const listRolesQuery = iamService.listRolesQuery({ accountId: params.accountId });
    const listUsersWithRolesQuery = aggregationService.listUsersWithRolesQuery({ accountId: params.accountId });

    return {
      listPermissionsQuery,
      listRolesQuery,
      listUsersWithRolesQuery,
    };
  },
  // Roles and permissions are read with suspense hooks all over the subtree, so they are warmed here
  // instead of mid-render. `prefetchQuery` and not `fetchQuery`: an account that may not read either
  // gets no data rather than a refusal, which is what `RolesComponent` redirects on. Not awaited: the
  // layout paints at once and each island suspends behind its own skeleton.
  loader: ({ context: { queryClient, listPermissionsQuery, listRolesQuery, listUsersWithRolesQuery } }) => {
    void queryClient.prefetchQuery(listPermissionsQuery);
    void queryClient.prefetchQuery(listRolesQuery);
    void queryClient.prefetchQuery(listUsersWithRolesQuery);
  },
  component: lazyRouteComponent(() => import('./route.component'), 'RolesComponent'),
});
